import PropTypes from "prop-types";
import React from "react";
import CheckIcon from "../../shared/Icons/CheckIcon";

const DaySheetSectionCard = ({ id, label, desc, checked, disabled, onToggle }) => (
  <label className={`sl-section-card${checked ? " is-active" : ""}${disabled ? " is-disabled" : ""}`}>
    <input type="checkbox" className="sl-visually-hidden" checked={checked} disabled={disabled}
           onChange={() => onToggle(id)} />
    <span className="sl-section-card-box" aria-hidden="true">
      {checked ? <CheckIcon fill="var(--sl-fg-white)" width="16" height="16" /> : null}
    </span>
    <span className="sl-section-card-text">
      <span className="sl-section-card-label">{label}</span>
      <span className="sl-section-card-desc">{desc}</span>
    </span>
  </label>
);

DaySheetSectionCard.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
};

DaySheetSectionCard.defaultProps = { disabled: false };

export default DaySheetSectionCard;
